import { render } from "./PointMap.vue?vue&type=template&id=667eed66"
import script from "./PointMap.vue?vue&type=script&lang=js"
export * from "./PointMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__